export const PENDING_CHANNEL_STORAGE_PREFIX = 'sympl.pending-channel.v1:';

/** Clear authentication and app state without losing unfinished channel requests. */
export const clearAppSessionStorage = () => {
  // Remove other entries in place: clearing and restoring a snapshot could lose a
  // request written by another tab, or lose recovery if restoring storage fails.
  const keys = Array.from({ length: localStorage.length }, (_, index) =>
    localStorage.key(index)
  );
  for (const key of keys) {
    if (key !== null && !key.startsWith(PENDING_CHANNEL_STORAGE_PREFIX))
      localStorage.removeItem(key);
  }
};
